import React, { useState, useEffect, useRef } from 'react'
import { Card, Row, Col } from 'antd'
import dayjs from 'dayjs'
import AntdTable from '@/components/table/AntdTable'
import { getSiteList, getReportPageList, getReportSummaryList, exportReport } from '@/services/reprint/reprint'
import SearchBar from '@/components/searchbar/SearchBar'
import {
  paginationInit,
  formatMessageNew,
  downLoadFileBlob,
  formatStartTime,
  formatEndTime,
  dateFormatYearMonthDay,
  initValueAndLabel,
  parseToArray
} from '@/utils/common'
import { modalError } from '@/utils/modalUtils'
const MAX_LIST_SIZE = 50
const startMonth = dayjs().subtract(6, 'day')
const endMonth = dayjs()
const REPRINT_METHOD = [
  { value: 2, label: () => formatMessageNew('languageObj.reprintReport.reprintMethodUpc') },
  { value: 1, label: () => formatMessageNew('languageObj.reprintReport.reprintMethodQr') }
]
const ReprintReport = () => {
  const mounting = useRef(false)
  let formRef = useRef(null)
  const [tableList, setTableList] = useState([])
  const [tableListTotal, setTableListTotal] = useState([])
  let searchListInit = [
    {
      type: 'timeRange',
      label: 'languageObj.reprintReport.reprintDate',
      key: 'timeRange',
      format: dateFormatYearMonthDay,
      isdefaultfilter: 'true',
      disabledDate: current => {
        let falg = current && current > dayjs().endOf('day')
        return falg
      },
      initialValues: [startMonth, endMonth],
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'select',
      label: 'languageObj.reprint.site',
      key: 'sites',
      allowClear: true,
      initialValues: [],
      mode: 'multiple',
      maxTagCount: 1,
      selectList: [],
      isdefaultfilter: 'true',
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'input',
      label: 'languageObj.commonLocale.productCode',
      key: 'productCode',
      initialValues: '',
      isdefaultfilter: 'true',
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'input',
      label: 'languageObj.commonLocale.upc',
      key: 'upc',
      initialValues: '',
      isdefaultfilter: 'true',
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'input',
      label: 'languageObj.commonLocale.qrCode',
      key: 'qrCode',
      initialValues: '',
      isdefaultfilter: 'true',
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'input',
      label: 'languageObj.clcRfidBindReport.rfidEpc',
      key: 'epc',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'input',
      label: 'languageObj.commonLocale.productName',
      key: 'productName',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      }
    },

    {
      type: 'input',
      label: 'languageObj.reprintReport.device',
      key: 'device',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'input',
      label: 'languageObj.reprintReport.printer',
      key: 'printer',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'textarea',
      label: 'languageObj.commonLocale.cartonNo',
      key: 'cartonNos',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'select',
      label: 'languageObj.reprintReport.reprintMethod',
      key: 'reprintTypes',
      allowClear: true,
      initialValues: [],
      mode: 'multiple',
      maxTagCount: 1,
      selectList: REPRINT_METHOD,
      spans: {
        xl: 8,
        xxl: 8
      }
    }
  ]
  const [searchList, setSearchList] = useState(searchListInit)
  const [queryFlag, setQueryFlag] = useState(false)
  const [pagination, setPagination] = useState(paginationInit)
  const tableColumnsTotalInit = [
    {
      title: formatMessageNew('languageObj.reprintReport.siteDate'),
      dataIndex: 'plant',
      width: 170,
      fixed: 'left'
    }
  ]
  const [tableColumnsTotal, setTableColumnsTotal] = useState(tableColumnsTotalInit)
  const tableColumns = [
    {
      title: formatMessageNew(`languageObj.reprint.site`),
      dataIndex: 'plant',
      width: 80
    },
    {
      title: formatMessageNew('languageObj.commonLocale.sku'),
      dataIndex: 'sku',
      width: 120
    },
    {
      title: formatMessageNew('languageObj.commonLocale.upc'),
      dataIndex: 'upc',
      width: 120
    },
    {
      title: formatMessageNew('languageObj.commonLocale.qrCode'),
      dataIndex: 'qr',
      width: 100,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.clcRfidBindReport.rfidEpc'),
      dataIndex: 'epc',
      width: 100,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.commonLocale.productName'),
      dataIndex: 'productName',
      width: 100,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.reprintReport.device'),
      dataIndex: 'operator',
      width: 120,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.reprintReport.printer'),
      dataIndex: 'printer',
      width: 100,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.commonLocale.cartonNo'),
      dataIndex: 'cartonNo',
      width: 120,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.reprintReport.reprintMethod'),
      dataIndex: 'reprintType',
      width: 120,
      render: text => {
        const target = REPRINT_METHOD.find(item => item.value === Number(text))
        return <div className="word_break_all">{target ? target.label() : text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.reprintReport.reprintDate'),
      dataIndex: 'reprintDate',
      width: 160,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    }
  ]
  useEffect(() => {
    getSelectOptions()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  const getSelectOptions = () => {
    getSiteList().then(res => {
      searchListInit.forEach(itemFirst => {
        if (itemFirst.key === 'sites') {
          const records = res.resultData || []
          itemFirst.selectList = initValueAndLabel(records)
        }
      })
      setSearchList([...searchListInit])
    })
  }
  useEffect(() => {
    if (mounting.current) {
      searchDataFun()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryFlag])
  const searchDataBtn = () => {
    if (!validateSearchParams()) {
      return
    }
    const pg = {
      ...pagination,
      currentPage: 1
    }
    mounting.current = true
    setPagination(pg)
    setQueryFlag(!queryFlag)
  }
  const searchClearDataBtn = () => {
    // formRef && formRef.current.clearForm()
    const pg = {
      ...pagination,
      currentPage: 1,
      total: 0
    }
    setPagination(pg)
    setTableList([])
    setTableListTotal([])
    setTableColumnsTotal(tableColumnsTotalInit)
    formRef && formRef.current.setValue({ timeRange: [] })
    // setQueryFlag(!queryFlag)
  }

  const getParams = type => {
    const info = (formRef.current && formRef.current.getSearchValue()) || {}
    const params = {
      ...info,
      startDate:
        type === 1 ? formatStartTime(info.timeRange, dateFormatYearMonthDay, 2) : formatStartTime(info.timeRange),
      endDate: type === 1 ? formatEndTime(info.timeRange, dateFormatYearMonthDay, 2) : formatEndTime(info.timeRange),
      cartonNos: parseToArray(info.cartonNos)
    }
    delete params.timeRange
    return params
  }

  const validateSearchParams = () => {
    const info = (formRef.current && formRef.current.getSearchValue()) || {}
    if (parseToArray(info.cartonNos).length > MAX_LIST_SIZE) {
      modalError({
        content: `${formatMessageNew('languageObj.commonLocale.cartonNo')}: ${formatMessageNew(
          'languageObj.obClaimReport.maxInputError'
        )}`
      })
      return false
    }
    return true
  }

  const searchDataFun = () => {
    const params = {
      ...getParams(),
      size: pagination.pageSize,
      pageNo: pagination.currentPage
    }
    const paramsSummary = {
      ...getParams(1),
      size: pagination.pageSize,
      pageNo: pagination.currentPage
    }
    getReportSummaryList(paramsSummary).then(res => {
      let dt = res.resultData.resultData
      let tableColumns0 = [...tableColumnsTotalInit]
      if (dt && dt.plantList && dt.plantList.length > 0) {
        for (let i = 0; i < dt.plantList.length; i++) {
          let elementI = dt.plantList[i]
          if (elementI.daySummaryList) {
            for (let j = 0; j < elementI.daySummaryList.length; j++) {
              const elementJ = elementI.daySummaryList[j]
              elementI[`qty${j}`] = elementJ.qty
              if (i === 0) {
                tableColumns0.push({
                  title: elementJ.date,
                  dataIndex: `qty${j}`,
                  width: 130
                })
              }
            }
          }
        }
      }
      setTableColumnsTotal(tableColumns0)
      setTableListTotal(dt.plantList || [])
    })
    getReportPageList(params).then(res => {
      const dt = res.resultData
      const records = dt.records
      setTableList(records)
      const pg = {
        ...pagination,
        total: dt.total
      }
      setPagination(pg)
    })
  }
  const handleTableChange = pagina => {
    const params = {
      ...pagination,
      currentPage: pagina.current,
      pageSize: pagina.pageSize
    }
    setPagination({ ...params })
    setQueryFlag(!queryFlag)
  }
  const downLoadFun = () => {
    if (!validateSearchParams()) {
      return
    }
    const params = {
      ...getParams()
    }
    exportReport(params).then(res => {
      downLoadFileBlob(res)
    })
  }
  return (
    <Card bodyStyle={{ padding: 4 }}>
      <div className="search-bar">
        <SearchBar
          ref={formRef}
          searchList={searchList}
          showCollapseBtn={true}
          showSearchBtn={true}
          showClearBtn={true}
          onSearch={searchDataBtn}
          onClear={searchClearDataBtn}
        />
      </div>

      <div className="content-container">
        <Row type="flex" justify="center">
          <Col span={17}>
            <AntdTable bordered columns={tableColumnsTotal} dataSource={tableListTotal} />
          </Col>
        </Row>
        <div className="mt30 pt10">
          <AntdTable
            dataSource={tableList}
            columns={tableColumns}
            // 独一无二的标识，不能重复
            columnsKey="columns_reprintReport_2"
            pagination={pagination}
            onDownload={downLoadFun}
            onChange={handleTableChange}
          />
        </div>
      </div>
    </Card>
  )
}
export default ReprintReport
